export const PRODUCT = 1;
export const OFFERT = 2;